const getters = {
  GetDarkMode(state) {
    return state.darkMode
  },
  GetProjects(state) {
    return state.projects.items
  },
  GetNavbar(state) {
    return state.navbar
  },
  GetNavbarItems(state) {
    return state.navbar.items
  },
  GetContact(state) {
    return state.navbar.contact
  },
  GetSendgridKey(state) {
    return state.sendgrid.key
  },
  GetReCaptchaKey(state) {
    return state.reCaptcha.key
  },
  GetToaster(state) {
    return state.toaster
  },
  GetApps(state) {
    return state.apps
  },
  GetError(state) {
    return state.error
  },
  GetButtons(state) {
    return state.buttons
  }
}

export default getters